import { useMemo } from 'react';
import { registerMutation, useMutation } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
const PATCH_FORM_FIELD_NAME = 'patchForm';
const PATCH_FORM = registerMutation({
  fieldName: PATCH_FORM_FIELD_NAME,
  args: ['formGuid', 'data'],
  fetcher({
    formGuid,
    data
  }) {
    return http.patch(`lead-flows/v1/lead-flows/${formGuid}`, {
      data
    });
  }
});
export default function usePatchForm() {
  const [patchForm, {
    error,
    loading
  }] = useMutation(PATCH_FORM);
  return useMemo(() => ({
    patchForm: variables => patchForm({
      variables
    }),
    error,
    loading
  }), [patchForm, error, loading]);
}